import { Component, computed, input, output } from '@angular/core';
import { PaginationState } from '../../blog.models';

@Component({
  selector: 'app-blog-pagination',
  templateUrl: './blog-pagination.html',
})
export class BlogPagination {
  readonly state = input.required<PaginationState>();
  readonly pageChange = output<number>();

  protected readonly pageNumbers = computed(() => {
    const total = this.state().totalPages;
    return Array.from({ length: total }, (_, i) => i + 1);
  });

  protected goToPage(page: number): void {
    if (page < 1 || page > this.state().totalPages || page === this.state().page) {
      return;
    }

    this.pageChange.emit(page);
  }
}
